// extracted by mini-css-extract-plugin
export var cardIcon = "_6m-5";
export var cardIconUnframed = "_6m-9";
export var checkboxCard = "_6m-0";
export var checkboxCardSelected = "_6m-4";
export var disabled = "_6m-2";
export var interactive = "_6m-1";
export var outerBorder = "_6m-3";
export var spacerMedium = "_6m-8";
export var spacerSmall = "_6m-7";
export var spacerXsmall = "_6m-6";